const translations = {
  // ===== NAVIGATION =====
  nav: {
    home: { en: 'The Philosophy', fr: 'La Philosophie', pt: 'A Filosofia' },
    team: { en: 'The Team', fr: "L'Équipe", pt: 'A Equipa' },
    theSetting: { en: 'The Setting', fr: 'Le Lieu', pt: 'O Lugar' },
    contact: { en: 'Contact', fr: 'Contact', pt: 'Contacto' },
    bookCall: { en: 'Book a Free Intro Call', fr: 'Réservez un Appel Gratuit', pt: 'Marque uma Chamada Gratuita' },
    theField: { en: 'The Field', fr: 'Le Champ', pt: 'O Campo' },
  },

  // ===== HOME PAGE =====
  home: {
    heroLine1: {
      en: 'Personalized healing retreats in an intimate home setting.',
      fr: 'Retraites de guérison personnalisées dans un cadre intime.',
      pt: 'Retiros de cura personalizados num ambiente intimo.',
    },
    heroLine2: {
      en: 'Multiple healers. One unified journey. Your transformation.',
      fr: 'Plusieurs guérisseurs. Un parcours unifié. Votre transformation.',
      pt: 'Varios curadores. Uma jornada unificada. A sua transformacao.',
    },
    heroLine3: {
      en: 'Every symptom is an intelligent adaptation. Every behaviour once served a purpose.',
      fr: "Chaque symptôme est une adaptation intelligente. Chaque comportement a un jour servi un objectif.",
      pt: 'Cada sintoma é uma adaptação inteligente. Cada comportamento já serviu um propósito.',
    },
    heroLine4: {
      en: 'The body is not working against us, it is communicating.',
      fr: "Le corps ne travaille pas contre nous, il communique.",
      pt: 'O corpo não trabalha contra nós, está a comunicar.',
    },
    heroLine5: {
      en: 'Healing is not about fixing what is broken. It is about creating enough safety for the body to release what it no longer needs to hold.',
      fr: "Guérir ne consiste pas à réparer ce qui est cassé. C'est créer suffisamment de sécurité pour que le corps libère ce qu'il n'a plus besoin de retenir.",
      pt: 'Curar não é consertar o que está partido. É criar segurança suficiente para que o corpo liberte o que já não precisa de reter.',
    },
    philosophyLabel: {
      en: 'THE PHILOSOPHY',
      fr: 'LA PHILOSOPHIE',
      pt: 'A FILOSOFIA',
    },
    philosophyTitle: {
      en: 'What is a Container?',
      fr: "Qu'est-ce qu'un Container ?",
      pt: 'O que e um Container?',
    },
    philosophyP1: {
      en: 'In a world asking for speed, performance, and quick fixes, we offer something different, a sanctuary where healing unfolds at the pace of truth.',
      fr: "Dans un monde qui réclame rapidité, performance et solutions miracles, nous offrons quelque chose de différent : un sanctuaire où la guérison se déploie au rythme de la vérité.",
      pt: 'Num mundo que pede velocidade, desempenho e solucoes rapidas, oferecemos algo diferente, um santuario onde a cura se desenrola ao ritmo da verdade.',
    },
    philosophyP2: {
      en: "Within CONTAINER we explore the person through multiple lenses: the body, the nervous system, emotional patterns, lived experience, the quantum field and symbolic frameworks such as Human Design, astrology, or other reflective tools.",
      fr: "Au sein de CONTAINER, nous explorons la personne à travers de multiples prismes : le corps, le système nerveux, les schémas émotionnels, l'expérience vécue, le champ quantique et des cadres symboliques tels que le Human Design, l'astrologie ou d'autres outils réflexifs.",
      pt: 'Dentro do CONTAINER, exploramos a pessoa através de múltiplas lentes: o corpo, o sistema nervoso, padrões emocionais, experiência vivida, o campo quântico e enquadramentos simbólicos como Human Design, astrologia ou outras ferramentas reflexivas.',
    },
    philosophyP3: {
      en: 'No single framework defines the person but together, they help reveal a coherent story.',
      fr: "Aucun cadre unique ne définit la personne, mais ensemble, ils aident à révéler une histoire cohérente.",
      pt: 'Nenhum enquadramento único define a pessoa, mas juntos, ajudam a revelar uma história coerente.',
    },
    philosophyP4: {
      en: 'Transformation happens because someone understands themselves intellectually; because the body has new experiences that make old protective strategies unnecessary, and because you allow your true essence to be seen.',
      fr: "La transformation se produit parce que quelqu'un se comprend intellectuellement ; parce que le corps vit de nouvelles expériences qui rendent les anciennes stratégies de protection inutiles, et parce que vous permettez à votre véritable essence d'être vue.",
      pt: 'A transformação acontece porque alguém se compreende intelectualmente; porque o corpo tem novas experiências que tornam as antigas estratégias de proteção desnecessárias, e porque permite que a sua verdadeira essência seja vista.',
    },
    philosophyP5: {
      en: 'Our role is not to change who someone is. Our role is to create the conditions in which their original nature can emerge.',
      fr: "Notre rôle n'est pas de changer qui est quelqu'un. Notre rôle est de créer les conditions dans lesquelles sa nature originelle peut émerger.",
      pt: 'O nosso papel não é mudar quem alguém é. O nosso papel é criar as condições nas quais a sua natureza original pode emergir.',
    },
    philosophyP6: {
      en: 'So you can remember your original way of being before protection became identity.',
      fr: "Pour que vous puissiez vous souvenir de votre manière originelle d'être, avant que la protection ne devienne identité.",
      pt: 'Para que possa lembrar-se da sua forma original de ser, antes de a proteção se tornar identidade.',
    },
    philosophyQuote: {
      en: 'Held in presence. Guided with care. Rooted in truth.',
      fr: 'Soutenu avec présence. Guidé avec bienveillance. Ancré dans votre vérité.',
      pt: 'Sustentado na presenca. Guiado com cuidado. Enraizado na verdade.',
    },
    circleHome: { en: 'The Home', fr: 'Le Lieu', pt: 'O Lugar' },
    circleHomeDesc: {
      en: 'The intelligence of nature, elemental grounding and silence.',
      fr: "L'intelligence de la nature, l'ancrage élémentaire et le silence.",
      pt: 'A inteligencia da natureza, o enraizamento elemental e o silencio.',
    },
    circleProtocol: { en: 'The Protocol', fr: 'Le Protocole', pt: 'O Protocolo' },
    circleProtocolDesc: {
      en: 'The rigorous weaving of ancient wisdom and advanced medical tech.',
      fr: "Le tissage rigoureux de la sagesse ancienne et de la technologie médicale avancée.",
      pt: 'A tecelagem rigorosa da sabedoria ancestral e tecnologia medica avancada.',
    },
    circlePeople: { en: 'The People', fr: 'Les Personnes', pt: 'As Pessoas' },
    circlePeopleDesc: {
      en: "Relational holding, the guide's deep presence and community.",
      fr: "Le soutien relationnel, la présence profonde du guide et la communauté.",
      pt: 'O suporte relacional, a presenca profunda do guia e a comunidade.',
    },
    retreatLabel: {
      en: 'YOUR PERSONAL RETREAT',
      fr: 'VOTRE RETRAITE PERSONNELLE',
      pt: 'O SEU RETIRO PESSOAL',
    },
    retreatTitle: {
      en: 'A Team Dedicated to Your Transformation',
      fr: 'Une Équipe Dédiée à Votre Transformation',
      pt: 'Uma Equipa Dedicada a Sua Transformacao',
    },
    retreatDesc: {
      en: 'Unlike traditional retreats, CONTAINER brings together a carefully curated team of practitioners who work simultaneously, creating a powerful, multidimensional healing experience tailored entirely to you.',
      fr: 'Contrairement aux retraites traditionnelles, CONTAINER réunit une équipe soigneusement sélectionnée de praticiens qui travaillent simultanément, créant une expérience de guérison puissante et multidimensionnelle entièrement adaptée à vous.',
      pt: 'Ao contrario dos retiros tradicionais, o CONTAINER reune uma equipa cuidadosamente selecionada de praticantes que trabalham simultaneamente, criando uma experiencia de cura poderosa e multidimensional totalmente adaptada a si.',
    },
    multipleHealers: { en: 'Multiple Healers', fr: 'Plusieurs Guérisseurs', pt: 'Varios Curadores' },
    multipleHealersDesc: {
      en: 'Experience the profound synergy of several practitioners working on you simultaneously, creating a unified field of healing.',
      fr: 'Vivez la synergie profonde de plusieurs praticiens travaillant sur vous simultanément, créant un champ unifié de guérison.',
      pt: 'Experimente a sinergia profunda de varios praticantes trabalhando em si simultaneamente, criando um campo unificado de cura.',
    },
    personalizedProtocol: { en: 'Personalized Protocol', fr: 'Protocole Personnalisé', pt: 'Protocolo Personalizado' },
    personalizedProtocolDesc: {
      en: 'Your retreat is meticulously designed around your unique needs, rhythms, and healing objectives. No template approaches.',
      fr: "Votre retraite est minutieusement conçue autour de vos besoins uniques, de vos rythmes et de vos objectifs de guérison. Aucune approche standardisée.",
      pt: 'O seu retiro e meticulosamente desenhado em torno das suas necessidades unicas, ritmos e objetivos de cura. Sem abordagens padronizadas.',
    },
    integratedModalities: { en: 'Integrated Modalities', fr: 'Modalités Intégrées', pt: 'Modalidades Integradas' },
    integratedModalitiesDesc: {
      en: 'Where ancient wisdom meets universal human knowledge, woven together through contemporary tools.',
      fr: "Là où la sagesse ancienne rencontre la connaissance humaine universelle, tissées ensemble à travers des outils contemporains.",
      pt: 'Onde a sabedoria ancestral encontra o conhecimento humano universal, tecidos juntos atraves de ferramentas contemporaneas.',
    },
    readyToBegin: { en: 'Ready to begin?', fr: 'Prêt à commencer ?', pt: 'Pronto para comecar?' },
    readyToBeginDesc: {
      en: 'Book a free discovery call so we can explore your needs and intentions. We will recommend the approach that will best support you at this moment.',
      fr: "Réservez un appel découverte gratuit afin que nous puissions explorer vos besoins et intentions. Nous vous recommanderons l'approche qui vous soutiendra le mieux en ce moment.",
      pt: 'Marque uma chamada de descoberta gratuita para que possamos explorar as suas necessidades e intencoes. Recomendaremos a abordagem que melhor o apoiara neste momento.',
    },
  },

  // ===== MODALITIES (marquee) =====
  modalities: {
    somaticTherapy: { en: 'Somatic Therapy', fr: 'Thérapie Somatique', pt: 'Terapia Somatica' },
    breathwork: { en: 'Breathwork', fr: 'Respiration', pt: 'Trabalho de Respiracao' },
    energyHealing: { en: 'Energy Healing', fr: 'Guérison Énergétique', pt: 'Cura Energetica' },
    soundTherapy: { en: 'Sound Therapy', fr: 'Thérapie Sonore', pt: 'Terapia Sonora' },
    plantMedicine: { en: 'Plant Medicine', fr: 'Médecine des Plantes', pt: 'Medicina das Plantas' },
    bodywork: { en: 'Bodywork', fr: 'Travail Corporel', pt: 'Trabalho Corporal' },
    quantumBioresonance: { en: 'Quantum Bioresonance', fr: 'Biorésonance Quantique', pt: 'Bioressonancia Quantica' },
    ancestralHealing: { en: 'Ancestral Healing', fr: 'Guérison Ancestrale', pt: 'Cura Ancestral' },
    movement: { en: 'Movement', fr: 'Mouvement', pt: 'Movimento' },
    coaching: { en: 'Coaching', fr: 'Coaching', pt: 'Coaching' },
    waterTherapy: { en: 'Water Therapy', fr: "Thérapie par l'Eau", pt: 'Terapia pela Agua' },
    fireCeremony: { en: 'Fire Ceremony', fr: 'Cérémonie du Feu', pt: 'Cerimonia do Fogo' },
  },

  // ===== THE SETTING PAGE =====
  setting: {
    label: { en: 'The Setting', fr: 'Le Lieu', pt: 'O Lugar' },
    title: { en: 'An <i>Actual</i> Home', fr: 'Une <i>Vraie</i> Maison', pt: 'Uma Casa <i>Real</i>' },
    desc: {
      en: 'Containment happens in the intimate embrace of a real home, not a sterile clinic or impersonal retreat center. Here, you are welcomed as a guest in the warmth and safety of a sanctuary.',
      fr: "Le contenant prend forme dans l'étreinte intime d'une vraie maison, pas une clinique stérile ou un centre de retraite impersonnel. Ici, vous êtes accueilli comme un invité dans la chaleur et la sécurité d'un sanctuaire.",
      pt: 'A contencao acontece no abraco intimo de uma casa real, nao uma clinica esteril ou um centro de retiro impessoal. Aqui, e recebido como convidado no calor e seguranca de um santuario.',
    },
    bannerLine1: {
      en: 'Nestled in the mystical landscapes near Sintra, Portugal, just 20 minutes from Lisbon,',
      fr: 'Niché dans les paysages mystiques près de Sintra, au Portugal, à seulement 20 minutes de Lisbonne,',
      pt: 'Aninhado nas paisagens misticas perto de Sintra, Portugal, a apenas 20 minutos de Lisboa,',
    },
    bannerLine2: {
      en: 'The Home offers a quiet, protected environment where nature guides the journey.',
      fr: 'The Home offre un environnement calme et protégé où la nature guide le parcours.',
      pt: 'The Home oferece um ambiente tranquilo e protegido onde a natureza guia a jornada.',
    },
    spaceLabel: { en: 'THE SPACE', fr: "L'ESPACE", pt: 'O ESPACO' },
    experienceTitle: { en: 'Experience The Home', fr: 'Découvrez The Home', pt: 'Experimente The Home' },
    experienceDesc: {
      en: 'Book a free discovery call to learn more about creating your personal retreat.',
      fr: 'Réservez un appel découverte gratuit pour en savoir plus sur la création de votre retraite personnelle.',
      pt: 'Marque uma chamada de descoberta gratuita para saber mais sobre como criar o seu retiro pessoal.',
    },
  },

  // ===== TEAM PAGE =====
  team: {
    label: { en: 'The Team', fr: "L'Équipe", pt: 'A Equipa' },
    trainedIn: { en: 'Trained in', fr: 'Formée en', pt: 'Formada em' },
    modalities: { en: 'Reiki Master  |  Spinal Flow  |  Sobada Maya', fr: 'Maître Reiki  |  Spinal Flow  |  Sobada Maya', pt: 'Mestre Reiki  |  Spinal Flow  |  Sobada Maya' },
    fromPerformance: { en: 'From Performance to Truth', fr: 'De la Performance à la Vérité', pt: 'Da Performance a Verdade' },
    immersionTitle: { en: 'Over a Decade of Immersion:', fr: "Plus d'une Décennie d'Immersion :", pt: 'Mais de uma Decada de Imersao:' },
    immersionDesc: {
      en: 'Learning and weaving modalities with a deep understanding of human experience:',
      fr: "Apprentissage et tissage de modalités avec une compréhension profonde de l'expérience humaine :",
      pt: 'Aprendendo e tecendo modalidades com uma compreensao profunda da experiencia humana:',
    },
    immersionList: {
      en: 'Reiki, Spinal Flow, bodywork, Sobada Maya, breathwork, meditation, movement,',
      fr: 'Reiki, Spinal Flow, travail corporel, Sobada Maya, respiration, méditation, mouvement,',
      pt: 'Reiki, Spinal Flow, trabalho corporal, Sobada Maya, respiracao, meditacao, movimento,',
    },
    immersionList2: {
      en: 'fire keeper, and plant medicine work.',
      fr: 'gardienne du feu et travail avec les plantes médicinales.',
      pt: 'guardia do fogo e trabalho com plantas medicinais.',
    },
    catalystTitle: { en: 'The Catalyst of Community:', fr: 'Le Catalyseur de la Communauté :', pt: 'O Catalisador da Comunidade:' },
    catalystDesc1: {
      en: 'Founder of Open Hearts Lisboa. This vibrant healing center revealed an essential truth:',
      fr: "Fondatrice d'Open Hearts Lisboa. Ce centre de guérison vibrant a révélé une vérité essentielle :",
      pt: 'Fundadora do Open Hearts Lisboa. Este vibrante centro de cura revelou uma verdade essencial:',
    },
    catalystDesc2: {
      en: 'being witnessed and held within a conscious collective accelerates transformation',
      fr: "être témoin et soutenu au sein d'un collectif conscient accélère la transformation",
      pt: 'ser testemunhado e sustentado dentro de um coletivo consciente acelera a transformacao',
    },
    catalystDesc3: {
      en: 'in ways no single modality can.',
      fr: "d'une manière qu'aucune modalité seule ne peut.",
      pt: 'de formas que nenhuma modalidade isolada consegue.',
    },
    synthesisTitle: { en: 'The Synthesis of a Healer', fr: "La Synthèse d'une Guérisseuse", pt: 'A Sintese de uma Curadora' },
    synthesisDesc1: {
      en: 'CONTAINER is the synthesis of her personal journey, her experience creating spaces,',
      fr: "CONTAINER est la synthèse de son parcours personnel, de son expérience dans la création d'espaces,",
      pt: 'CONTAINER e a sintese da sua jornada pessoal, da sua experiencia na criacao de espacos,',
    },
    synthesisDesc2: {
      en: 'and her vision for a conscious way of living.',
      fr: 'et de sa vision pour un mode de vie conscient.',
      pt: 'e da sua visao para um modo de vida consciente.',
    },
    howWeWorkTitle: { en: 'How We Work', fr: 'Comment Nous Travaillons', pt: 'Como Trabalhamos' },
    howWeWorkP1: {
      en: 'Each journey begins with a personal assessment.',
      fr: 'Chaque parcours commence par une évaluation personnelle.',
      pt: 'Cada jornada comeca com uma avaliacao pessoal.',
    },
    howWeWorkP2: {
      en: 'You are invited to complete a detailed questionnaire, opening a process of self-inquiry into your health, emotional landscape, lifestyle, and intentions.',
      fr: "Vous êtes invité à remplir un questionnaire détaillé, ouvrant un processus d'introspection sur votre santé, votre paysage émotionnel, votre mode de vie et vos intentions.",
      pt: 'E convidado a preencher um questionario detalhado, abrindo um processo de auto-investigacao sobre a sua saude, paisagem emocional, estilo de vida e intencoes.',
    },
    howWeWorkP2b: {
      en: 'We create an integrative consciousness protocol by working simultaneously through the body, the nervous system, awareness, and meaning.',
      fr: 'Nous créons un protocole de conscience intégrative en travaillant simultanément à travers le corps, le système nerveux, la conscience et le sens.',
      pt: 'Criamos um protocolo de consciência integrativa trabalhando simultaneamente através do corpo, do sistema nervoso, da consciência e do significado.',
    },
    howWeWorkP3: {
      en: 'To deepen this understanding, a biofeedback session is conducted with a specialized practitioner. Using advanced technology, we gather insights across the physical, energetic, and subtle layers of your system.',
      fr: "Pour approfondir cette compréhension, une séance de biofeedback est réalisée avec un praticien spécialisé. Grâce à une technologie avancée, nous recueillons des informations sur les couches physiques, énergétiques et subtiles de votre système.",
      pt: 'Para aprofundar esta compreensao, uma sessao de biofeedback e realizada com um praticante especializado. Usando tecnologia avancada, recolhemos informacoes sobre as camadas fisicas, energeticas e subtis do seu sistema.',
    },
    howWeWorkP4: {
      en: 'This allows us to refine your protocol with greater precision.',
      fr: 'Cela nous permet de raffiner votre protocole avec une plus grande précision.',
      pt: 'Isto permite-nos refinar o seu protocolo com maior precisao.',
    },
    howWeWorkP5: {
      en: 'From there, the most aligned therapies and practitioners are carefully selected for you.',
      fr: 'À partir de là, les thérapies et praticiens les plus alignés sont soigneusement sélectionnés pour vous.',
      pt: 'A partir dai, as terapias e praticantes mais alinhados sao cuidadosamente selecionados para si.',
    },
    ourApproachTitle: { en: 'Our Approach', fr: 'Notre Approche', pt: 'A Nossa Abordagem' },
    ourApproachP1: {
      en: 'We work as a collective — a network of practitioners with complementary skills, brought together through intention and experience.',
      fr: "Nous travaillons en collectif — un réseau de praticiens aux compétences complémentaires, réunis par l'intention et l'expérience.",
      pt: 'Trabalhamos como um coletivo — uma rede de praticantes com competencias complementares, reunidos pela intencao e experiencia.',
    },
    ourApproachP2: {
      en: 'Rather than offering isolated sessions, we create a coherent and integrated healing experience, where each practitioner contributes to a shared purpose: supporting your transformation.',
      fr: "Plutôt que de proposer des séances isolées, nous créons une expérience de guérison cohérente et intégrée, où chaque praticien contribue à un objectif commun : soutenir votre transformation.",
      pt: 'Em vez de oferecer sessoes isoladas, criamos uma experiencia de cura coerente e integrada, onde cada praticante contribui para um proposito partilhado: apoiar a sua transformacao.',
    },
    readyToMeet: { en: 'Ready to meet?', fr: 'Prêt à nous rencontrer ?', pt: 'Pronto para conhecer?' },
    readyToMeetDesc: {
      en: 'Book a free discovery call to explore how we can support your journey.',
      fr: 'Réservez un appel découverte gratuit pour explorer comment nous pouvons soutenir votre parcours.',
      pt: 'Marque uma chamada de descoberta gratuita para explorar como podemos apoiar a sua jornada.',
    },
  },

  // ===== CONTACT PAGE =====
  contact: {
    label: { en: 'Begin Your Journey', fr: 'Commencez Votre Parcours', pt: 'Comece a Sua Jornada' },
    title: { en: "Let's Connect", fr: 'Connectons-nous', pt: 'Vamos Conectar' },
    desc: {
      en: "Leave your details for an introductory call. Together, we'll explore whether CONTAINER is the space for your healing journey.",
      fr: "Laissez vos coordonnées pour un appel d'introduction. Ensemble, nous explorerons si CONTAINER est l'espace pour votre parcours de guérison.",
      pt: 'Deixe os seus dados para uma chamada introdutoria. Juntos, exploraremos se o CONTAINER e o espaco para a sua jornada de cura.',
    },
    nameLabel: { en: 'Your Name', fr: 'Votre Nom', pt: 'O Seu Nome' },
    namePlaceholder: { en: 'How shall we address you?', fr: 'Comment devons-nous vous appeler ?', pt: 'Como devemos chama-lo?' },
    emailLabel: { en: 'Email Address', fr: 'Adresse Email', pt: 'Endereco de Email' },
    phoneLabel: { en: 'Phone Number', fr: 'Numéro de Téléphone', pt: 'Numero de Telefone' },
    phoneOptional: { en: '(optional)', fr: '(facultatif)', pt: '(opcional)' },
    messageLabel: { en: 'Your Message', fr: 'Votre Message', pt: 'A Sua Mensagem' },
    messagePlaceholder: {
      en: 'Share what brings you here, what you\'re seeking, or any questions you may have...',
      fr: 'Partagez ce qui vous amène ici, ce que vous recherchez, ou toute question que vous pourriez avoir...',
      pt: 'Partilhe o que o traz aqui, o que procura, ou quaisquer perguntas que possa ter...',
    },
    sending: { en: 'Sending...', fr: 'Envoi en cours...', pt: 'Enviando...' },
    submit: { en: 'Request Intro Call', fr: "Demander un Appel d'Introduction", pt: 'Solicitar Chamada Introdutoria' },
    responseTime: { en: 'We typically respond within 24-48 hours.', fr: 'Nous répondons généralement sous 24 à 48 heures.', pt: 'Normalmente respondemos dentro de 24 a 48 horas.' },
    location: { en: 'Location', fr: 'Localisation', pt: 'Localizacao' },
    address: { en: 'Sintra, Portugal, 20 minutes from Lisbon', fr: 'Sintra, Portugal, à 20 minutes de Lisbonne', pt: 'Sintra, Portugal, a 20 minutos de Lisboa' },
  },

  // ===== THE FIELD PAGE =====
  field: {
    label: { en: 'The Field', fr: 'Le Champ', pt: 'O Campo' },
    heroTitle: {
      en: 'The Frequency Container',
      fr: 'Le Conteneur de Fréquence',
      pt: 'O Contentor de Frequência',
    },
    introP1: {
      en: 'At CONTAINER, we work not only with the individual, but also with the environment in which the work takes place.',
      fr: "Chez CONTAINER, nous travaillons non seulement avec l'individu, mais aussi avec l'environnement dans lequel le travail se déroule.",
      pt: 'No CONTAINER, trabalhamos não apenas com o indivíduo, mas também com o ambiente em que o trabalho acontece.',
    },
    introP2: {
      en: 'Our space is held within a continuous frequency field, created through the iQube and maintained 24 hours a day, 7 days a week.',
      fr: "Notre espace est maintenu dans un champ de fréquence continu, créé par l'iQube et maintenu 24 heures sur 24, 7 jours sur 7.",
      pt: 'O nosso espaço é mantido dentro de um campo de frequência contínuo, criado através do iQube e mantido 24 horas por dia, 7 dias por semana.',
    },
    introP3: {
      en: 'The intention is simple: Sound and brainwave are medicine and needs to be part of any treatment, so we create an environment that invites more presence, more relaxation, receptivity and deeper alignment.',
      fr: "L'intention est simple : le son et les ondes cérébrales sont une médecine et doivent faire partie de tout traitement, nous créons donc un environnement qui invite à plus de présence, de relaxation, de réceptivité et d'alignement plus profond.",
      pt: 'A intenção é simples: o som e as ondas cerebrais são medicina e precisam fazer parte de qualquer tratamento, por isso criamos um ambiente que convida a mais presença, mais relaxamento, recetividade e alinhamento mais profundo.',
    },
    introP4: {
      en: 'You can simply spend time within the Field, or enter into a more intentional one-to-one experience with the technology and with us.',
      fr: "Vous pouvez simplement passer du temps dans le Champ, ou entrer dans une expérience individuelle plus intentionnelle avec la technologie et avec nous.",
      pt: 'Pode simplesmente passar tempo dentro do Campo, ou entrar numa experiência individual mais intencional com a tecnologia e connosco.',
    },
    introP5: {
      en: 'A one-to-one frequency experience which combine sound, brainwave entrainment, the iQube field and frequency-infused water. Each session is individual and Bodywork can be added. You are invited to arrive with an intention, settle into the experience, receive the selected frequency and sound environment, and take time afterwards to integrate what you noticed. Frequency-infused water is included as part of the experience, creating a simple ritual of receiving and integration.',
      fr: "Une expérience de fréquence individuelle qui combine le son, l'entraînement des ondes cérébrales, le champ iQube et de l'eau infusée de fréquences. Chaque séance est individuelle et le travail corporel peut être ajouté. Vous êtes invité à arriver avec une intention, à vous installer dans l'expérience, à recevoir la fréquence et l'environnement sonore sélectionnés, et à prendre le temps ensuite d'intégrer ce que vous avez remarqué. L'eau infusée de fréquences est incluse dans l'expérience, créant un simple rituel de réception et d'intégration.",
      pt: 'Uma experiência de frequência individual que combina som, sincronização de ondas cerebrais, o campo iQube e água infundida com frequências. Cada sessão é individual e o trabalho corporal pode ser adicionado. É convidado a chegar com uma intenção, a instalar-se na experiência, a receber a frequência e o ambiente sonoro selecionados, e a dedicar tempo depois para integrar o que notou. A água infundida com frequências está incluída como parte da experiência, criando um simples ritual de receção e integração.',
    },
    iqubeTitle: { en: 'THE iQUBE', fr: "L'iQUBE", pt: 'O iQUBE' },
    iqubeP1: {
      en: 'The iQube is a frequency technology developed around scalar-field concepts, sound and brainwave entrainment.',
      fr: "L'iQube est une technologie de fréquence développée autour de concepts de champ scalaire, du son et de l'entraînement des ondes cérébrales.",
      pt: 'O iQube é uma tecnologia de frequência desenvolvida em torno de conceitos de campo escalar, som e sincronização de ondas cerebrais.',
    },
    iqubeP2: {
      en: 'At CONTAINER, the iQube is not simply something we switch on for a session. It is part of the environment. The field is maintained continuously, creating an ongoing energetic and sensory dimension to the space in which we live and work.',
      fr: "Chez CONTAINER, l'iQube n'est pas simplement quelque chose que nous allumons pour une séance. Il fait partie de l'environnement. Le champ est maintenu en continu, créant une dimension énergétique et sensorielle permanente dans l'espace où nous vivons et travaillons.",
      pt: 'No CONTAINER, o iQube não é simplesmente algo que ligamos para uma sessão. Faz parte do ambiente. O campo é mantido continuamente, criando uma dimensão energética e sensorial contínua no espaço onde vivemos e trabalhamos.',
    },
    iqubeP3: {
      en: 'For those who want to explore the experience more intentionally, we offer private one-to-one sessions where the iQube becomes the focus of a dedicated period of receiving.',
      fr: "Pour ceux qui souhaitent explorer l'expérience de manière plus intentionnelle, nous proposons des séances privées individuelles où l'iQube devient le centre d'une période dédiée de réception.",
      pt: 'Para aqueles que querem explorar a experiência de forma mais intencional, oferecemos sessões privadas individuais onde o iQube se torna o foco de um período dedicado de receção.',
    },
    freqTitle: { en: 'THE FREQUENCY CONTAINER', fr: 'LE CONTENEUR DE FRÉQUENCE', pt: 'O CONTENTOR DE FREQUÊNCIA' },
    freqP1: {
      en: 'A one-to-one frequency experience combining sound, brainwave entrainment, the iQube field and frequency-infused water.',
      fr: "Une expérience de fréquence individuelle combinant le son, l'entraînement des ondes cérébrales, le champ iQube et de l'eau infusée de fréquences.",
      pt: 'Uma experiência de frequência individual combinando som, sincronização de ondas cerebrais, o campo iQube e água infundida com frequências.',
    },
    freqP2: {
      en: 'A space to slow down, receive and explore deeper states of relaxation, presence and awareness.',
      fr: "Un espace pour ralentir, recevoir et explorer des états plus profonds de relaxation, de présence et de conscience.",
      pt: 'Um espaço para abrandar, receber e explorar estados mais profundos de relaxamento, presença e consciência.',
    },
    freqP3: {
      en: 'Each session is individual. You are invited to arrive with an intention, settle into the experience, receive the selected frequency and sound environment, and take time afterwards to integrate what you noticed. Frequency-infused water is included as part of the experience, creating a simple ritual of receiving and integration.',
      fr: "Chaque séance est individuelle. Vous êtes invité à arriver avec une intention, à vous installer dans l'expérience, à recevoir la fréquence et l'environnement sonore sélectionnés, et à prendre le temps ensuite d'intégrer ce que vous avez remarqué. L'eau infusée de fréquences est incluse dans l'expérience, créant un simple rituel de réception et d'intégration.",
      pt: 'Cada sessão é individual. É convidado a chegar com uma intenção, a instalar-se na experiência, a receber a frequência e o ambiente sonoro selecionados, e a dedicar tempo depois para integrar o que notou. A água infundida com frequências está incluída como parte da experiência, criando um simples ritual de receção e integração.',
    },
    questTitle: { en: 'THE QUEST 9', fr: 'LE QUEST 9', pt: 'O QUEST 9' },
    questP1: {
      en: 'Alongside the iQube, Ines Pessoa works with the Quest 9, a bioresonance-based system used within her individual sessions.',
      fr: "En complément de l'iQube, Ines Pessoa travaille avec le Quest 9, un système basé sur la biorésonance utilisé dans ses séances individuelles.",
      pt: 'Paralelamente ao iQube, Ines Pessoa trabalha com o Quest 9, um sistema baseado em bioressonância utilizado nas suas sessões individuais.',
    },
    questP2: {
      en: 'The Quest 9 offers a different way of exploring the relationship between the individual and the frequency field, working with measurements and energetic/bioresonance information as part of a personalised session.',
      fr: "Le Quest 9 offre une manière différente d'explorer la relation entre l'individu et le champ de fréquence, en travaillant avec des mesures et des informations énergétiques/biorésonance dans le cadre d'une séance personnalisée.",
      pt: 'O Quest 9 oferece uma forma diferente de explorar a relação entre o indivíduo e o campo de frequência, trabalhando com medições e informações energéticas/bioressonância como parte de uma sessão personalizada.',
    },
    questP3: {
      en: 'Ines brings her own experience and approach to this work, creating a space for individual exploration, observation and awareness. The Quest 9 sessions are private and one-to-one.',
      fr: "Ines apporte sa propre expérience et son approche à ce travail, créant un espace d'exploration individuelle, d'observation et de conscience. Les séances Quest 9 sont privées et individuelles.",
      pt: 'Ines traz a sua própria experiência e abordagem a este trabalho, criando um espaço de exploração individual, observação e consciência. As sessões Quest 9 são privadas e individuais.',
    },
    compIntro: {
      en: 'The iQube and Quest 9 therefore offer two complementary approaches:',
      fr: "L'iQube et le Quest 9 offrent donc deux approches complémentaires :",
      pt: 'O iQube e o Quest 9 oferecem assim duas abordagens complementares:',
    },
    compIqube: {
      en: 'The iQube works with the environment and the experience of receiving frequency.',
      fr: "L'iQube travaille avec l'environnement et l'expérience de réception de fréquence.",
      pt: 'O iQube trabalha com o ambiente e a experiência de receber frequência.',
    },
    compQuest: {
      en: 'The Quest 9 works with the individual through a personalised bioresonance session.',
      fr: "Le Quest 9 travaille avec l'individu à travers une séance de biorésonance personnalisée.",
      pt: 'O Quest 9 trabalha com o indivíduo através de uma sessão de bioressonância personalizada.',
    },
    compTogether: {
      en: 'Together, they become part of the wider Field we are creating at CONTAINER.',
      fr: "Ensemble, ils font partie du Champ plus large que nous créons chez CONTAINER.",
      pt: 'Juntos, tornam-se parte do Campo mais amplo que estamos a criar no CONTAINER.',
    },
    livingTitle: { en: 'LIVING WITH THE FIELD', fr: 'VIVRE AVEC LE CHAMP', pt: 'VIVER COM O CAMPO' },
    livingP1: {
      en: 'The Field is not something you need to understand before you experience it.',
      fr: "Le Champ n'est pas quelque chose que vous devez comprendre avant de le vivre.",
      pt: 'O Campo não é algo que precisa de compreender antes de o experienciar.',
    },
    livingP2: {
      en: 'You can come with curiosity.',
      fr: 'Vous pouvez venir avec curiosité.',
      pt: 'Pode vir com curiosidade.',
    },
    livingP3: {
      en: 'You can come with an intention.',
      fr: 'Vous pouvez venir avec une intention.',
      pt: 'Pode vir com uma intenção.',
    },
    livingP4: {
      en: 'Or you can simply come and receive.',
      fr: 'Ou vous pouvez simplement venir et recevoir.',
      pt: 'Ou pode simplesmente vir e receber.',
    },
    livingP5: {
      en: 'We are interested in what happens when technology, consciousness, body, environment and presence meet — and in creating a space where you can slow down enough to notice.',
      fr: "Nous nous intéressons à ce qui se passe quand la technologie, la conscience, le corps, l'environnement et la présence se rencontrent — et à la création d'un espace où vous pouvez suffisamment ralentir pour remarquer.",
      pt: 'Estamos interessados no que acontece quando tecnologia, consciência, corpo, ambiente e presença se encontram — e em criar um espaço onde possa abrandar o suficiente para reparar.',
    },
    livingCta: {
      en: 'Enter the Field.',
      fr: 'Entrez dans le Champ.',
      pt: 'Entre no Campo.',
    },
    livingCta2: {
      en: 'Receive. Explore. Integrate.',
      fr: 'Recevoir. Explorer. Intégrer.',
      pt: 'Receber. Explorar. Integrar.',
    },
    readyTitle: {
      en: 'Experience the Field',
      fr: 'Découvrez le Champ',
      pt: 'Experimente o Campo',
    },
    readyDesc: {
      en: 'Book a free discovery call to learn more about the frequency experience at CONTAINER.',
      fr: "Réservez un appel découverte gratuit pour en savoir plus sur l'expérience de fréquence chez CONTAINER.",
      pt: 'Marque uma chamada de descoberta gratuita para saber mais sobre a experiência de frequência no CONTAINER.',
    },
  },
};

export const t = (key, lang) => {
  const keys = key.split('.');
  let value = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  return value?.[lang] || value?.['en'] || key;
};

export default translations;
